import React, { useState, useContext, useEffect } from 'react';
import './CameraInformation.scss';
import { ReactComponent as ArrowDown } from '../../assets/icons/keyboard_arrow_down-24px.svg';
import clsx from 'clsx';
import { CSSTransitionGroup } from 'react-transition-group';

export default () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="additional-filter">
      <button
        className="additional-filter__button"
        onClick={() => setOpen(!open)}
      >
        <ArrowDown className={clsx({
          'additional-filter__button__arrow': true,
          'additional-filter__button__arrow--open': open
        })} />
        <span className="additional-filter__button__text">Rover camera names</span>
      </button>
      <CSSTransitionGroup
        transitionName="additional-filter__items--animation"
        transitionEnterTimeout={450}
        transitionLeaveTimeout={600}>
        {open
          ? (
            <div className="camera-information-wrapper">
              <h3>List of cameras for the individual rovers as an indication of what to look for</h3>
              <p><strong>Curiosity:</strong> Front Hazard Avoidance Camera (FHAZ), Rear Hazard Avoidance Camera(RHAZ), Mast Camera (MAST), Chemistry and Camera Complex (CHEMCAM), Mars Hand Lens Imager (MAHLI), Mars Descent Imager (MARDI), Navigation Camera (NAVCAM)</p>
              <p><strong>Spirit:</strong> Front Hazard Avoidance Camera (FHAZ), 	Rear Hazard Avoidance Camera (RHAZ), Navigation Camera (NAVCAM), Panoramic Camera (PANCAM), Miniature Thermal Emission Spectrometer (MINITES)</p>
              <p><strong>Opportunity:</strong> Front Hazard Avoidance Camera (FHAZ), Rear Hazard Avoidance Camera (RHAZ), Navigation Camera (NAVCAM), Panoramic Camera (PANCAM), Miniature Thermal Emission Spectrometer (MINITES)</p>
              <p><strong>Perseverance:</strong> SHERLOC WATSON Camera (SHERLOC_WATSON), Front Hazard Avoidance Camera - Left (FRONT_HAZCAM_LEFT_A), Front Hazard Avoidance Camera - Right (FRONT_HAZCAM_RIGHT_A), Navigation Camera - Left (NAVCAM_LEFT), Navigation Camera - Right (NAVCAM_RIGHT), Mast Camera Zoom - Right (MCZ_RIGHT), Mast Camera Zoom - Left (MCZ_LEFT), SuperCam Remote Micro Imager (SUPERCAM_RMI), Rear Hazard Avoidance Camera - Left (REAR_HAZCAM_LEFT), Rear Hazard Avoidance Camera - Right (REAR_HAZCAM_RIGHT), Parachute Up-Look Camera B (EDL_PUCAM2), Parachute Up-Look Camera A (EDL_PUCAM1), Rover Up-Look Camera (EDL_RUCAM), Descent Stage Down-Look Camera (EDL_DDCAM)</p>
            </div>
          )
          : null}
      </CSSTransitionGroup>

    </div>
  )
}